import { fetchShareLink } from "src/api/fetchShareLink";
import { useTheme, useMediaQuery } from "@mui/material";
import { Share } from "@capacitor/share";
import { useSafeAccessAuth0Token } from "src/hooks/useSafeAccessAuth0Token";
import { useCallback, useContext, useState } from "react";
import { WidgetContext } from "src/contexts/WidgetContext";

export const useHandleShare = () => {
  const { clientIdToken } = useContext(WidgetContext);
  const { getSafeAccessAuth0Token } = useSafeAccessAuth0Token();
  const theme = useTheme();
  const isMobileOrTablet = useMediaQuery(theme.breakpoints.down("lg")) && ("ontouchstart" in window || navigator.maxTouchPoints > 0);

  const [isCheckmark, setIsCheckmark] = useState(false);
  const [showToast, setShowToast] = useState(false);

  const handleShare = useCallback(
    async (
      message_id: string,
      title: string = "Check out this RotoGPT analysis!",
      audioUrl?: string,
      shareUrl?: string,
      platformId?: string,
      leagueId?: string,
      authId?: string,
    ) => {
      const client_id = "ROTO";
      try {
        const accessAuthToken = await getSafeAccessAuth0Token();
        if (!accessAuthToken) {
          return;
        }

        let fullUrl = shareUrl || "";

        if (!fullUrl && message_id) {
          fullUrl = await fetchShareLink(
            client_id,
            message_id,
            accessAuthToken,
            audioUrl,
            platformId,
            leagueId,
            authId,
          );
        }

        if (!fullUrl) {
          console.error("Share failed: URL is not available");
          return;
        }

        if (isMobileOrTablet && fullUrl) {
          await Share.share({
            title: title,
            url: fullUrl,
            dialogTitle: "Share this analysis",
          });
          setShowToast(true);
        } else if (fullUrl) {
          await navigator.clipboard.writeText(fullUrl);
          setShowToast(true);
        }

        setIsCheckmark(true);
        setTimeout(() => {
          setShowToast(false);
          setIsCheckmark(false);
        }, 1500);
      } catch (error) {
        console.error("Error fetching or sharing the link: ", error);
      }
    },
    [getSafeAccessAuth0Token, isMobileOrTablet],
  );

  return { handleShare, isCheckmark, showToast };
};
